import React, { useEffect, useState } from 'react';
import Icon from '../Icon/Icon';
import Select from '../Select';
import APopover from '../APopover';
import {
  DropdownContainer,
  DropdownSelect,
  DropdownSelectSection,
  DropdownWrapper,
  DropdownFilterSection,
  DropdownFilterItem,
  SearchInputContainer,
  SearchInput,
  ItemDescriptionSection,
  ResultItemSection,
  ResultItem,
  ItemDescriptionTitle,
  ItemDescriptionText,
} from './styles';
import {
  getAllCategories,
  getAllCategoriesFn,
} from 'store/categories/categoriesSlice';
import { connect, MapDispatchToProps } from 'react-redux';
import {
  searchProvider,
  searchProviderFn,
} from 'store/providers/providerSlice';
import { LoadingWrapper } from '../ItemPicker/styles';
import BubbleLoading from '../BubbleLoading';
import logo from '../../assets/images/search-empty.svg';
import { appDispatch } from 'store/store';
import { languageDirection } from '../../i18n';

interface IDispatchToProps {
  getAll: () => ReturnType<typeof getAllCategoriesFn>;
  searchFilter: (
    queryString: string,
    start: number,
    count: number,
    filters: string[],
    latitude?: number,
    longitude?: number
  ) => ReturnType<typeof searchProviderFn>;
}
type IProps = {
  modalType?: boolean;
  callbackFunction?: () => void;
};
type IComponentProps = IDispatchToProps & IProps;
type resultItem = { title: string; address: string; id: string };
type IResultProps = {
  mostFrequent?: boolean;
  callbackFunction?: (id: string) => void;
  getMostFrequent: () => resultItem[];
  data: resultItem;
};
type itemType = { label: string; value: string; show?: boolean };
type IState = {
  searchText: string;
  loading: boolean;
  optionsTree: { [key: string]: any };
  allSelected: Array<{ name: string; index: number; id: string }>;
  cities?: Array<itemType>;
  stationTypes?: Array<itemType>;
  stationServices?: Array<itemType>;
  insurance?: Array<itemType>;
  allCities?: Array<itemType>;
  allTypes?: Array<itemType>;
  allServices?: Array<itemType>;
  allInsurances?: Array<itemType>;
  mostFrequent: Array<resultItem>;
  result: Array<resultItem>;
  pos?: { long: number; lat: number };
};
interface ISearchSelect {
  name: string;
  value: 'cities' | 'stationTypes' | 'stationServices' | 'insurance';
  placeholder: string;
  optionList: string;
  multiChoice: boolean;
  id: number;
}
let timeout: any;
const ItemDescription: React.FunctionComponent<IResultProps> = ({
  data,
  mostFrequent,
  callbackFunction,
  getMostFrequent,
}) => {
  function setMostFrequent() {
    let items = getMostFrequent();
    items = items.filter((item) => item.id !== data.id);
    items.unshift(data);
    items = items.splice(0, 3);
    localStorage.setItem('mostFrequent', JSON.stringify(items));
  }
  return (
    <ResultItem>
      {mostFrequent ? (
        <Icon
          type={'rotate-ccw'}
          color={'#00897B'}
          style={{ paddingLeft: '1.2rem' }}
        />
      ) : null}
      <ItemDescriptionSection
        onClick={setMostFrequent}
        href={'/' + data.id}
        target="_blank"
      >
        <ItemDescriptionTitle>{data.title}</ItemDescriptionTitle>
        <ItemDescriptionText>{data.address}</ItemDescriptionText>
      </ItemDescriptionSection>
      {mostFrequent ? (
        <Icon
          type={'trash-2'}
          className="pointer"
          color={'#00897B'}
          onClick={() => callbackFunction && callbackFunction(data.id)}
          style={{ fontSize: '1.5rem' }}
        />
      ) : (
        <Icon
          type={
            languageDirection() === 'rtl' ? 'chevron-left' : 'chevron-right'
          }
          color={'#00897B'}
          style={{ fontSize: '1.5rem' }}
        />
      )}
    </ResultItem>
  );
};
const Search: React.FunctionComponent<IComponentProps> = ({
  getAll,
  searchFilter,
  modalType,
  callbackFunction,
}) => {
  const [state, setState] = useState<IState>({
    searchText: '',
    loading: false,
    optionsTree: {},
    allSelected: [],
    cities: [],
    stationTypes: [],
    stationServices: [],
    insurance: [],
    allCities: [],
    allTypes: [],
    allServices: [],
    allInsurances: [],
    mostFrequent: [],
    result: [],
  });
  const [open, setOpen] = useState(false);
  const searchSelects: ISearchSelect[] = [
    {
      name: '',
      value: 'cities',
      placeholder: 'شهر',
      optionList: 'allCities',
      multiChoice: false,
      id: 30,
    },
    {
      name: '',
      value: 'stationTypes',
      placeholder: 'نوع مرکز',
      optionList: 'allTypes',
      multiChoice: true,
      id: 1,
    },
    {
      name: '',
      value: 'stationServices',
      placeholder: 'خدمات مرکز',
      optionList: 'allServices',
      multiChoice: true,
      id: 42,
    },
    {
      name: '',
      value: 'insurance',
      placeholder: 'بیمه',
      optionList: 'allInsurances',
      multiChoice: true,
      id: 38,
    },
  ];
  useEffect(() => {
    let tempState = JSON.parse(localStorage.getItem('searchMemory') ?? '{}');
    if (tempState.expirationTime < new Date().getTime()) {
      localStorage.setItem('searchMemory', '{}');
      tempState = {};
    } else delete tempState.expirationTime;
    const mostFrequent = getMostFrequent();
    setState((prevState) => ({
      ...prevState,
      ...tempState,
      mostFrequent: mostFrequent,
    }));
    window.navigator.geolocation.getCurrentPosition((pos) => {
      setState((prevState) => ({
        ...prevState,
        pos: { long: pos.coords.longitude, lat: pos.coords.latitude },
      }));
    });
    getAll().then((res: any) => {
      const tree: any = {};
      res.map((item: any) => {
        if (!item.parent) {
          if (!tree[item.id]) tree[item.id] = {};
          tree[item.id].name = item.name;
          tree[item.id].show = item.activeStatus === 'Active';
        } else {
          if (!tree[item.parent]) tree[item.parent] = {};
          if (!tree[item.parent].values) tree[item.parent].values = [];
          if (item.activeStatus === 'Active')
            tree[item.parent].values.push(item);
        }
      });
      const tempState: any = { optionsTree: tree };
      searchSelects.map((select) => {
        tempState[select.optionList] = [];
        tree[select.id]?.values?.map((item: any) => {
          tempState[select.optionList].push({
            label: item.name,
            value: item.id,
          });
          if (tree[item.id]) {
            tree[item.id]?.values?.map((subItem: any) => {
              tempState[select.optionList].push({
                label: subItem.name,
                value: subItem.id,
              });
            });
          }
        });
      });
      setState((prevState) => ({ ...prevState, ...tempState }));
    });
  }, []);
  function getMostFrequent(): resultItem[] {
    const items = JSON.parse(localStorage.getItem('mostFrequent') ?? '[]');
    return items ?? [];
  }
  function removeMostFrequentItem(id: string): void {
    const tempState = { ...state };
    tempState.mostFrequent = tempState.mostFrequent.filter(
      (item) => item.id !== id
    );
    let items = getMostFrequent();
    items = items.filter((item) => item.id !== id);
    localStorage.setItem('mostFrequent', JSON.stringify(items));
    setState(tempState);
  }
  function searchCallback(wait = false) {
    clearTimeout(timeout);
    function timeoutCallback() {
      let tempState: any;
      setState((prevState) => {
        tempState = prevState;
        return prevState;
      });
      const memory = {
        searchText: tempState.searchText,
        optionsTree: tempState.optionsTree,
        allSelected: tempState.allSelected,
        cities: tempState.cities,
        stationTypes: tempState.stationTypes,
        stationServices: tempState.stationServices,
        insurance: tempState.insurance,
        allCities: tempState.allCities,
        allTypes: tempState.allTypes,
        allServices: tempState.allServices,
        allInsurances: tempState.allInsurances,
        mostFrequent: tempState.mostFrequent,
        result: tempState.result,
        expirationTime: new Date().getTime() + 60 * 60 * 1000,
      };
      localStorage.setItem('searchMemory', JSON.stringify(memory));
      if (!tempState.searchText && tempState.allSelected.length === 0) return;
      const filters: string[] = [];
      searchSelects.map((select) => {
        let str = 'categoryId:';
        if (tempState[select.value].length > 0) {
          tempState[select.value].map((item: itemType) => {
            str += item.value + ',';
          });
          str = str.substr(0, str.length - 1);
          filters.push(str);
        }
      });
      searchFilter(
        tempState.searchText,
        0,
        100,
        filters,
        state.pos?.lat,
        state.pos?.long
      ).then((res: any) => {
        const list: any = [];
        res?.map((item: any) => {
          list.push({
            title: item.name,
            address: item.address.text,
            id: item.username ?? item.id,
          });
        });
        setState((prevState) => ({
          ...prevState,
          result: list,
          loading: false,
        }));
      });
    }
    timeout = setTimeout(timeoutCallback, wait ? 1500 : 10);
  }
  function changeSelectedItem(type: string, selectedItem: any, list?: any) {
    const tempState: IState = {
      ...state,
      allSelected: [],
      loading: true,
    };
    if (type === 'add') {
      tempState[selectedItem.value] = list;
    } else {
      state[selectedItem.id]?.splice(selectedItem.index, 1);
      tempState[selectedItem.id] = [...(state[selectedItem.id] ?? [])];
    }
    searchSelects.map((select) =>
      tempState[select.value]?.map((item, index) =>
        tempState.allSelected.push({
          name: item.label,
          id: select.value,
          index: index,
        })
      )
    );
    setState((prevState) => ({ ...prevState, ...tempState }));
    searchCallback();
  }
  return (
    <APopover
      curveBorder
      trigger="click"
      show={open}
      onShowChange={(e) => setOpen(e)}
      target={
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <SearchInputContainer
            style={{
              backgroundColor: modalType ? 'white' : '',
              // marginTop: open ? '-40px' : 0,
              // opacity:open ? 0 : 1
            }}
          >
            <Icon
              type={modalType ? 'arrow-right' : 'search'}
              color={modalType ? 'rgba(0, 0, 0, 0.6)' : 'white'}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                if (modalType && callbackFunction) callbackFunction();
              }}
            />
            <SearchInput
              placeholder={'نام مرکز، بیمارستان، آزمایشگاه و...'}
              value={state.searchText}
              onChange={(event: any) => {
                setState({
                  ...state,
                  searchText: event.target.value,
                  loading: true,
                });
                searchCallback(true);
              }}
              style={{
                color: modalType ? 'rgba(0, 0, 0, 0.6)' : 'white',
              }}
            />
            <span
              className="pointer"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                setState((prevState) => ({
                  ...prevState,
                  loading: true,
                  searchText: '',
                }));
                searchCallback(true);
              }}
            >
              <Icon
                type={'x'}
                color={modalType ? 'rgba(0, 0, 0, 0.6)' : 'white'}
              />
            </span>
          </SearchInputContainer>
        </div>
      }
    >
      <DropdownWrapper>
        <DropdownContainer>
          <DropdownSelectSection>
            {searchSelects.map((item: ISearchSelect, index: number) =>
              state[item.optionList].length &&
              state.optionsTree[item.id].show ? (
                <DropdownSelect key={index}>
                  <Select
                    values={state[item.value]}
                    options={state[item.optionList]}
                    multiChoice={item.multiChoice}
                    showValues={!item.multiChoice}
                    selectionIndicator={true}
                    onChangeValues={(selectedItem) => {
                      changeSelectedItem('add', item, selectedItem);
                    }}
                    placeholder={item.placeholder}
                  />
                </DropdownSelect>
              ) : null
            )}
          </DropdownSelectSection>
          <DropdownFilterSection>
            {state.allSelected.map((item, index) => (
              <DropdownFilterItem key={index}>
                <Icon
                  type={'x'}
                  color={'#00897B'}
                  className="pointer"
                  onClick={() => {
                    changeSelectedItem('remove', item);
                  }}
                />
                <span style={{ marginRight: '5px' }}>{item.name}</span>
              </DropdownFilterItem>
            ))}
          </DropdownFilterSection>
          {state.mostFrequent?.length > 0 &&
          !state.searchText &&
          !state.allSelected.length ? (
            <ResultItemSection>
              {state.mostFrequent?.map((item: any, index) => (
                <ItemDescription
                  key={index}
                  data={item}
                  getMostFrequent={getMostFrequent}
                  mostFrequent
                  callbackFunction={removeMostFrequentItem}
                />
              ))}
            </ResultItemSection>
          ) : null}
          {!state.searchText && !state.allSelected.length ? (
            <div
              style={{
                height: '80px',
                textAlign: 'center',
                lineHeight: '80px',
              }}
            >
              برای جستجو کلمه‌ای بنویسید یا فیلتری را انتخاب کنید.
            </div>
          ) : state.loading ? (
            <div style={{ height: '200px', position: 'relative' }}>
              <LoadingWrapper>
                <BubbleLoading />
              </LoadingWrapper>
            </div>
          ) : state.result.length > 0 ? (
            <ResultItemSection>
              {state.result.map((item: any, index) => (
                <ItemDescription
                  key={index}
                  data={item}
                  getMostFrequent={getMostFrequent}
                />
              ))}
            </ResultItemSection>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <img src={logo} alt="rastech" style={{ width: '50%' }} />
              <div>مرکز مورد نظر شما یافت نشد.</div>
            </div>
          )}
        </DropdownContainer>
      </DropdownWrapper>
    </APopover>
  );
};

const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, any> = () => {
  return {
    getAll: () => {
      return appDispatch(getAllCategories({}));
    },
    searchFilter: (
      queryString: string,
      start: number,
      count: number,
      filters: string[],
      latitude?: number,
      longitude?: number
    ) => {
      return appDispatch(
        searchProvider({
          queryString,
          variant: null,
          start,
          count,
          filters,
          latitude,
          longitude,
        })
      );
    },
  };
};

export default connect(null, mapDispatchToProps)(Search);
